import { render, staticRenderFns } from "./BarnaulModal.vue?vue&type=template&id=520ec16a&"
import script from "./BarnaulModal.vue?vue&type=script&lang=js&"
export * from "./BarnaulModal.vue?vue&type=script&lang=js&"
import style0 from "./BarnaulModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports